import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useLocation } from 'react-router-dom';
import { surveyPortalMixpanel } from '../../../../vendor/mixpanel';

const SurveyClosed = () => {
  const supportEmail = 'professionals@newtonx.com';
  const copyEmailToClipboard = () => {
    navigator.clipboard.writeText(supportEmail);
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const SEID = queryParams.get('SEID');
  const source = queryParams.get('survey_host');
  const surveyId = queryParams.get('survey_id');
  const environment = process.env.REACT_APP_ENV;
  let suffix = '';
  if (environment === 'local' || environment === 'development') {
    suffix = '.dev';
  } else if (environment === 'staging') {
    suffix = '.staging';
  }
  // UTM Sign-up URL
  const signUpUrl = `https://professionals${suffix}.newtonx.com/?utm_source=${source}&utm_medium=survey-experience&utm_campaign=survey-${SEID}&utm_content=survey-closed-page&utm_term=survey_id_${surveyId}`;
  const hasTrackedRef = React.useRef(false);
  React.useEffect(() => {
    if (!hasTrackedRef.current && SEID) {
      surveyPortalMixpanel.track('Survey Closed Page Viewed', {
        SSEID: SEID,
        survey_id: surveyId,
        survey_host: source,
      });
      hasTrackedRef.current = true;
    }
  }, [SEID, source]);
  const trackSignUp = () => {
    surveyPortalMixpanel.track('Sign Up Button Clicked', {
      SSEID: SEID,
      survey_id: surveyId,
      survey_host: source,
      source: 'Survey',
      button_location: 'Closed page',
    });
  };
  return (
    <Box maxWidth="480px">
      <Typography variant={'h2'} marginBottom="16px" fontWeight={700}>
        This survey is closed
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="16px">
        We received all the responses we needed and this survey is now complete.
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="32px">
        Thanks for your interest. We hope to work with you soon!
      </Typography>
      <Typography variant={'h3'} marginBottom="16px" fontWeight={700}>
        Need to contact us?
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="16px">
        You can reach out to us at:
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'left',
          marginLeft: '0',
          display: 'flex',
        }}
      >
        <Typography variant={'body1'} color={'text.secondary'} fontWeight={700} marginBottom="32px">
          {supportEmail}
        </Typography>
        <Button
          sx={{
            padding: '0px',
            height: '24px',
            paddingRight: '26px',
            paddingBottom: '0',
          }}
          onClick={copyEmailToClipboard}
        >
          <ContentCopyIcon sx={{ height: '16px', fill: '#262B2D' }} />
        </Button>
      </Typography>
      <Typography variant={'h3'} marginBottom="16px" fontWeight={700}>
        Find your next paid opportunity
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="16px">
        Not part of the NewtonX Professionals Community? Sign up to find more paid opportunities
        that match your experience.
      </Typography>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        href={signUpUrl}
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackSignUp}
      >
        SIGN UP
      </Button>
    </Box>
  );
};

export default SurveyClosed;
